import CustomCSSTransition from "./CustomCSSTransition";
import { useState, useEffect, useRef } from "react";
import { IoIosArrowDown } from "react-icons/io";

/**
 * Custom ComboBox
 */

const ComboBox = ({
  options,
  isSearchable,
  placeholder,
  selectedClassNames,
  dropDownClassNames,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedObject, setSelectedObject] = useState(options[0]);
  const [inputValue, setInputValue] = useState("");
  const [filteredOptions, setFilteredOptions] = useState(options);
  const dropDownRef = useRef(null);

  /**
   * dropdown tailwindcss classes
   */
  const dropDownClasses = Object.values({
    initialClasses: "relative",
    minWidth: "min-w-[200px]",
    text: "text-sm",
    ...dropDownClassNames,
  }).join(" ");

  console.log(isSearchable);

  /** selectedElement tailwindcss classes */
  const selectedClasses = Object.values({
    initialClasses: "overflow-hidden cursor-pointer font-medium",
    padding: !isSearchable ? "px-4 py-2" : "pr-4",
    display: "flex items-center justify-between",
    backgroundColor: "bg-white",
    border: "border rounded-full",
    ...selectedClassNames,
  }).join(" ");

  /** inputElement tailwindcss classes */
  const inputClasses = Object.values({
    padding: "pl-4 py-2",
    width: "w-full",
    height: "h-full",
    focus: "focus:outline-none",
  }).join(" ");

  const handleInputChange = (event) => {
    if (event.target.value.trim(" ").length === 0) {
      setInputValue("");
      setFilteredOptions(options);
      return;
    }

    setInputValue(event.target.value);
    setFilteredOptions(searchOption(inputValue));
  };

  const isSelected = (option) => {
    if (!selectedObject) return false;
    return option === selectedObject;
  };

  /**
   * search an option of combobox list based on input value
   */
  const searchOption = (value) => {
    return options.filter(
      (option) =>
        option.label.toLocaleLowerCase().indexOf(value.toLocaleLowerCase()) >= 0
    );
  };

  const handleDropDownClick = () => {
    toggleIsOpen();
  };

  const toggleIsOpen = (value) => {
    setIsOpen((prevValue) => (value === undefined ? !prevValue : value));
  };

  const handleOptionClick = (option) => {
    if (!isSelected(option)) {
      setSelectedObject(option);
      setInputValue(option.label);
    }
    toggleIsOpen(false);
  };

  /**
   * close the dropdown when the user clicks outside it.
   */
  useEffect(() => {
    const handler = (e) => {
      if (dropDownRef.current && !dropDownRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    window.addEventListener("click", handler);
    return () => window.removeEventListener("click", handler);
  }, []);

  return (
    <div className={dropDownClasses}>
      <div
        onClick={(event) => handleDropDownClick(event)}
        ref={dropDownRef}
        className={selectedClasses}
      >
        {isSearchable ? (
          <div>
            <form action="/" onSubmit={(event) => event.preventDefault()}>
              <input
                type="text"
                value={inputValue}
                placeholder={placeholder}
                onChange={(event) => handleInputChange(event)}
                className={inputClasses}
              />
            </form>
          </div>
        ) : (
          <div className={`flex`}>
            <span>{selectedObject ? selectedObject.label : placeholder}</span>
          </div>
        )}

        <div className="flex items-center">
          <span
            className={`arrow-icon inline-block transition-all duration-300 ${
              isOpen ? "rotate-180" : ""
            }`}
          >
            <IoIosArrowDown />
          </span>
        </div>
      </div>
      <CustomCSSTransition inValue={isOpen}>
        <div className="absolute top-full w-full z-10 font-normal rounded-lg overflow-hidden shadow-xl">
          <ul className="flex flex-col max-h-44 overflow-auto bg-white ">
            {filteredOptions.map((option) => {
              return (
                <li
                  key={option.id}
                  className={`px-4 py-2 cursor-pointer hover:bg-gray-100 transition-all duration-200 shrink-0 ${
                    isSelected(option) ? "text-primary-700" : ""
                  }`}
                  onClick={() => handleOptionClick(option)}
                >
                  {option.label}
                </li>
              );
            })}
          </ul>
        </div>
      </CustomCSSTransition>
    </div>
  );
};

export default ComboBox;
